
import { Flex, message } from "antd";
import AgentMapWithPopup from "./AgentMapWithPopup";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchAllocationDetails, getFieldAgentLocation } from "../../../assets/api/allocation";
import AgentDetailsTable from "../AgentDetailsTable/AgentDetailsTable";
import "./AgentDetailsComp.scss";
import toast from "react-hot-toast";

const AgentDetailsComp = () => {
  const { state } = useLocation();
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);
  const [mapData, setMapData] = useState({
    loading: false,
    data: {}
  });

  useEffect(() => {
    const getAllocationDetails = async () => {
      if (!state?.id) {
        return;
      }
      setLoading(true)

      try {
        const res = await fetchAllocationDetails(state?.user_id, token);

        if (res?.status === 200) {

          setLoading(false)
          setCases(res?.data?.data || []);

        }
      } catch (error) {
        message.error(error?.message || "Failed to fetch agent details")

        setLoading(false)

      }
    };



    getAllocationDetails();
    getFAdetails();
  }, [state, token]);

  const getFAdetails = async () => {
    try {
      const res = await getFieldAgentLocation(token, state?.id);
      setMapData((prev) => ({
        ...prev,
        loading: true
      }))
      console.log(res, 'response');
      if (res?.status === 200) {
        setMapData((prev) => ({
          ...prev,
          data: res?.data?.data || {},
          loading: false
        }))
      } else {
        toast.error("Failed to fetch agent location");
        setMapData((prev) => ({
          ...prev,
          data: {},
          loading: false
        }))
      }
    } catch (error) {
      // Optionally handle error
    }
  }


  return (
    <Flex className="agent-details-main">
      <p className="main-heading">Agent Details</p>
      <Flex className="first-component">
        <Flex className="heading-box">
          <p className="headline">Personal Information</p>
        </Flex>
        <Flex className="detailed-box">
          <Flex className="inner-box">
            <Flex className="label">Name</Flex>
            <Flex className="description">{state?.name || "N/A"}</Flex>
          </Flex>
          <Flex className="inner-box">
            <Flex className="label">Mobile</Flex>
            <Flex className="description">{state?.mobile_no || "N/A"}</Flex>
          </Flex>
          <Flex className="inner-box">
            <Flex className="label">Role</Flex>
            <Flex className="description">{state?.role || "N/A"}</Flex>
          </Flex>
          <Flex className="inner-box">
            <Flex className="label">Date of Joining</Flex>
            <Flex className="description">
              {moment(state?.date?._of_joinings).format("L") || "N/A"}
            </Flex>
          </Flex>
        </Flex>
        <Flex className="detailed-box">
          <Flex className="inner-box">
            <Flex className="label">Address</Flex>
            <Flex className="description">{state?.address || "N/A"}</Flex>
          </Flex>
          <Flex className="inner-box">
            <Flex className="label">Email ID</Flex>
            <Flex className="description">{state?.email || "N/A"}</Flex>
          </Flex>
          <Flex className="inner-box">
            <Flex className="label">Total Distance Travelled</Flex>
            <Flex className="description">{state?.Distance || "N/A"}</Flex>
          </Flex>
          <Flex className="inner-box">
            <Flex className="label">Total Time Taken</Flex>
            <Flex className="description">{state?.Time || "N/A"}</Flex>
          </Flex>
        </Flex>
      </Flex>
      <Flex className="map-component">
        <AgentMapWithPopup data={mapData} />
      </Flex>
      <Flex className="table-component">
        <p className="table-heading">Cases Assigned</p>
        <AgentDetailsTable data={cases} loading={loading} />
      </Flex>
    </Flex>
  );
};

export default AgentDetailsComp;
